import { ETutorialAudienceType } from "../../Enum/ETutorialAudienceType"
import { EEnableStatusType } from "../../Enum/EEnableStatusType"
import { BaseModel } from "../Generics/BaseModel"

export class TutorialEntity extends BaseModel {
  id: number

  category: string

  title: string

  youtubeUrl: string

  status: EEnableStatusType

  audience: ETutorialAudienceType

  createdAt?: string

  constructor(data: Partial<TutorialEntity> = {}) {
    super()

    this.id = data.id ?? -1

    this.category = data.category ?? ""

    this.title = data.title ?? ""

    this.youtubeUrl = data.youtubeUrl ?? ""

    this.status = data.status ?? EEnableStatusType.Active

    this.audience = data.audience ?? ETutorialAudienceType.Store

    this.createdAt = data.createdAt
  }
}
